import { css } from "@emotion/core";
import {
  color,
  fontTypes,
  fontWeight,
  fontSizes,
} from "../../constants/commons";

export const navBarStyle = (isBlackNav: boolean | undefined) => css`
  .width-style {
    width: 10em;
  }
  .font-name-style {
    color: ${color.black};
    font-family: ${fontTypes.bold};
    font-weight: ${fontWeight.light};
  }

  .responsive-logo-width {
    cursor: pointer;
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-width {
      width: 90%;
    }
    .responsive-logo-width {
      width: 50%;
    }
    .responsive-partnername-width {
      width: 32%;
    }

    .mobile-tablet-responsive-margin {
      margin: 1em 0;
    }
    .mobile-view-navFooter-style {
      position: absolute;
      bottom: 0em;
      width: 93%;
      justify-content: center;
    }

    .drawer-mobile-image-style {
      width: 40%;
    }
    .static {
      position: fixed;
      top: 0em;
      width: 100%;
      box-shadow: 0 0.25em 0.625em 0 ${color.shadow};
      z-index: 4;
      background: linear-gradient(
        -153.43494882292202deg,
        ${color.whitishGray} 0%,
        ${color.whitishGray} 100%
      );
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .responsive-width {
      width: 93%;
    }
    .responsive-logo-width {
      width: 65%;
    }
    .responsive-partnername-width {
      width: 25%;
    }

    .mobile-tablet-responsive-margin {
      margin: 1em 0;
    }
    .mobile-view-navFooter-style {
      position: absolute;
      bottom: 1em;
      width: 93%;
    }
    .drawer-mobile-image-style {
      width: 40%;
    }
    .static {
      position: fixed;
      top: 0em;
      width: 100%;
      z-index: 4;
      background: linear-gradient(
        -153.43494882292202deg,
        ${color.whitishGray} 0%,
        ${color.whitishGray} 100%
      );
      box-shadow: 0 0.25em 0.625em 0 ${color.shadow};
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .responsive-width {
      width: 94%;
    }
    .responsive-logo-width {
      width: 75%;
    }
    .responsive-partnername-width {
      width: 30%;
    }

    .mobile-view-navFooter-style {
      position: absolute;
      bottom: 1em;
      width: 93%;
    }
    .drawer-mobile-image-style {
      width: 40%;
    }
    .static {
      position: fixed;
      top: 0em;
      width: 100%;
      z-index: 4;
      background: ${color.white};
      box-shadow: 0 0.25em 0.625em 0 ${color.shadow};
    }
    .mobile-tablet-responsive-margin {
      margin: 0 0.5em;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .responsive-width {
      width: 15%;
    }
    .responsive-logo-width {
      width: 85%;
    }
    .responsive-partnername-width {
      width: 100%;
    }
    .static {
      position: fixed;
      top: 0em;
      width: 100%;
      z-index: 4;
      background: ${color.white};
      box-shadow: 0 0.25em 0.625em 0 ${color.shadow};
    }
    .navbar-padding-container {
      padding: 0 6em;
    }
    .mobile-tablet-responsive-margin {
      margin: 0 0.5em;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .responsive-width {
      width: 10%;
    }
    .mobile-tablet-responsive-margin {
      margin: 0 0.5em;
    }
    .responsive-logo-width {
      width: 85%;
    }
    .responsive-partnername-width {
      width: 100%;
    }
    .static {
      position: fixed;
      top: 0em;
      width: 100%;
      z-index: 4;
      background: ${color.white};
      box-shadow: 0 0.25em 0.625em 0 ${color.shadow};
    }
    .navbar-padding-container {
      padding: 0.35em 10em;
    }
  }
  ul {
    list-style-type: none;
  }
  .drawer-links-style {
    a {
      color: ${color.black};
    }
  }
  .horizontal-line {
    border: 0.0625em solid ${color.gray};
    height: 0.0625em;
  }

  .navbar {
    .user-button-style {
      margin-right: 1em;
      margin-left: 0.5em;
      background: ${isBlackNav ? color.lightBlack : "none"};
    }
    .user-info-container:hover {
      cursor: pointer;
    }
    .user-info-container {
      display: flex;
      align-items: center;
      .ant-avatar {
        margin-right: 0.75em;
      }
      .name-container {
        margin-right: 1em;
        max-width: 5em;
        .user-name {
          font-family: ${fontTypes.bold};
          font-size: ${fontSizes.sm};
          color: ${isBlackNav ? color.white : color.black};
        }
        .user-profession {
          font-family: ${fontTypes.bodyFont};
          font-size: ${fontSizes.xs};
          color: ${color.lightishGray};
        }
      }
    }
  }
  .user-dropdown-container {
    background: ${color.white};
    position: absolute;
    width: max-content;
    top: 100%;
  }

  .side-nav-logout-btn {
    width: 80%;
    padding: 1em 0em;
  }

  /* dropdownList */
  .dropdown-list {
    list-style-type: none;
    padding: 10px 0px;
    margin: 0px;
    display: inline-block;
    transform: translateY(-20%);
    opacity: 0;
    transition: all 0.5s;
    max-height: 0;
    li {
      cursor: pointer;
      display: none;
      justify-content: space-between;
      align-items: center;
      font-family: $body-font;
      font-size: 14px;
      color: #303233;
      padding: 10px 35px;
      span {
        position: relative;
        top: 2px;
      }
      img {
        margin-left: 10px;
      }
    }
    li:hover {
      background-color: #edf0f2;
    }
  }

  /* dropdownList open animation*/
  .dropdown-list-active {
    transform: translateY(0);
    opacity: 1;
    max-height: 100%;
    li {
      display: flex;
    }
  }

  .black-nav {
    min-height: 4em;
    background: ${color.lightBlack};
    #navbarNav {
      .nav-link {
        color: ${color.white};
      }
    }
  }
`;
